import { HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { FirebaseAuthService } from "../services/firebase-auth/firebase-auth.service";
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private firebaseAuth: FirebaseAuthService) { }

	intercept(req: HttpRequest<any>, next: HttpHandler) {
		let authToken = this.firebaseAuth.AuthToken;
		let authReq = req;

		if (req.url.toLowerCase().indexOf('/token') === -1
			&& req.url.toLowerCase().indexOf('/checkuuid') === -1
			&& req.url.toLowerCase().indexOf('/companytype') === -1) {
			// Clone the request and replace the original headers with
			// cloned headers, updated with the authorization

			authReq = req.clone({
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authToken}`,
					'x-api-key': environment.apiKey
				})
			});
		}

		// send cloned request with header to the next handler.
		return next.handle(authReq);
	}
}